// extracted by mini-css-extract-plugin
module.exports = {"root":"dTBQvQlx","title":"ZwY3XxbG","headerWrapper":"vBhyo5rW"};